export default {
  ONE_DAY: '1D',
  THREE_DAYS: '3D',
  SEVEN_DAYS: '7D',
  ONE_MONTH: '1M',
  THREE_MONTHS: '3M',
  // create a default value for the DateRangeSelect component
  DEFAULT_DAYS_TO_SEARCH: 7,
};
